// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"m_-z"};